export interface MemberQrDetails {
  fullName?: string;
  email?: string;
  fatherOrHusbandName?: string;
  phone?: string;
  dateOfBirth?: string;
  currentCityVillage?: string;
  currentCity?: string;
  currentDistrict?: string;
  currentState?: string;
  currentPinCode?: string;
  bloodGroup?: string;
  enrollmentNumber?: string;
  enrollment_number?: string;
  permanentEnrollmentNumber?: string;
  memberType?: string;
  designation?: string;
  branch?: string;
  memberStatus?: string;
  validUntil?: string;
}

const clean = (value?: string) => String(value || '-').replace(/\s+/g, ' ').trim();

export const buildMemberQrValue = (member: MemberQrDetails): string => {
  const enrollment = clean(member.enrollment_number || member.enrollmentNumber || member.permanentEnrollmentNumber);
  return `https://ccroindia.com/member/${encodeURIComponent(enrollment)}`;
};
